export default function ProjectFilter () {
    const filterTrigger = document.querySelector('#filter-trigger');
    const searchTrigger = document.querySelector('#search-trigger');

    const searchFieldGroup = document.querySelector('#search-fieldgroup');
    const statusFieldGroup = document.querySelector('#status-fieldgroup');
    const sortDateFieldGroup = document.querySelector('#sort-date-fieldgroup');

    if (filterTrigger) {
        filterTrigger.addEventListener('click', (event) => {
            event.stopPropagation();

            filterTrigger.classList.toggle('active');

            statusFieldGroup.classList.toggle('visible');
            sortDateFieldGroup.classList.toggle('visible');
        });
    }

    if (searchTrigger) {
        searchTrigger.addEventListener('click', (event) => {
            event.stopPropagation();

            searchTrigger.classList.toggle('active');

            searchFieldGroup.classList.toggle('visible');
        });
    }
}
